<template>
  <div class="modal">
	  <div class="dimmer" @click="on_dimmer_close()"></div>
    <div class="popup" :class="popup_cls">

      <slot></slot>

      <div class="modal-closer" v-if="btnClose" @click="on_btn_close()">X</div>
    </div>    
  </div>
</template>


<script>
export default {
  props: {
    dimmerClose: { type:Boolean, default:true },
    btnClose: { type:Boolean, default:true },
    noPad: { type:Boolean, default:false },
  },
  data(){
    return {
      
    }
  },
  computed:{
    
    popup_cls(){
      var cls = {}
      if( this.noPad ) cls['no-padding'] = true
      return cls
    },
    
  },
  methods: {

    on_dimmer_close(){
      if( this.dimmerClose === false ) return
      this.$emit('close')
    },

    on_btn_close(){
      this.$emit('close')
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue